import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import * as api from "../../../common/manipurCommon/API";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import Utils from "../../../common/manipurCommon/Utils";
import HPCSchedules from "../HPC Schedule/hpcSchedule";
import HPCBatchAthlete from "../HPC Batch Athlete/hpcBatchAthlete";
import HPCAttendance from "../HPC Attendance/hpcAttendance";
import HPCAssessment from "../HPC Assessment/hpcAssessment";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { usePermissions } from "../../../common/PermissionContext";

const TrialBatch = () => {

    const [coachList, setCoachList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [programList, setProgramList] = useState<any[]>([]);
    const [hpcList, setHpcList] = useState<any[]>([]);
    const [geoList, setGeoList] = useState<any[]>([]);
    const [scdlOrCount, setScdlOrCount] = useState<any[]>([]);
    const [geoId, setGeoId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [batchName, setBatchName] = useState('');
    const [coachId, setCoachId] = useState('');
    const [sportId, setSportId] = useState('');
    const [hpcId, setHpcId] = useState('');
    const [programId, setProgramId] = useState('');
    const [callModule, setCallModule] = useState('');
    const [batchStatus, setBatchStatus] = useState('');
    const [searchInput, setSearchInput] = useState("");
    const [titleName, setTitleName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openModalOthers, setOpenModalOthers] = useState(false);

    const formRef = useRef(null);
    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];
    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchBatchInfo();
    }, [])

    async function fetchBatchInfo() {
        setIsLoading(true);
        const batchResponse = await func.batchInfo(null);
        setBatchList(Array.isArray(batchResponse.batches) ? batchResponse.batches : [])
        setIsLoading(false);
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    async function newBatch() {
        setIsEdit(false)
        setOpenModal(true)
        setBatchName('')
        setSportId('')
        setCoachId('')
        setGeoId('')
        setHpcId('')
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : [])
        const progResponse = await func.program(null);
        setProgramList(Array.isArray(progResponse) ? progResponse : [])
    }

    const filteredData = batchList.filter((datas) => {
        // const values = Object.values(datas).map((value) =>
        //     value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        // return values.some((value) => value.includes(searchInput.toLowerCase()));
        const search = searchInput.toLowerCase();

        return (
            datas.batchName?.toLowerCase().includes(search) ||
            datas.batchCode?.toLowerCase().includes(search) ||
            datas.center?.geoHPCName?.toLowerCase().includes(search) ||
            datas.sport?.sportName?.toLowerCase().includes(search) ||
            datas.program?.programName?.toLowerCase().includes(search) ||
            datas.coach?.coachName?.toLowerCase().includes(search) ||
            datas.status?.name?.toLowerCase().includes(search) ||
            datas.schedule?.displayDays?.toLowerCase().includes(search)
        );
    });

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateBatch();
            } else {
                const formData = new FormData();
                formData.append("geoHPCId", hpcId);
                formData.append("name", batchName);
                formData.append("coachId", coachId);
                formData.append("sportId", sportId);
                formData.append("programId", programId);

                const createBatch = api.HPCBatch;
                fetch(createBatch, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchBatchInfo();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateBatch() {
        const formData = new FormData();
        formData.append("geoHPCId", hpcId);
        formData.append("name", batchName);
        formData.append("coachId", coachId);
        formData.append("sportId", sportId);
        formData.append("programId", programId);
        formData.append("status", batchStatus);

        const updatebtch = api.HPCBatch + '/' + batchId;
        fetch(updatebtch, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchBatchInfo();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    async function editBatch(btchId: any) {
        // const btchId = btchId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.hpcBatch(btchId);
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : []);
        const hpcResponse = await func.getHpcByGeography(getDetails.geographyId);
        setHpcList(Array.isArray(hpcResponse) ? hpcResponse : [])
        const cochResponse = await func.getCoachesByHpc(getDetails.geoHPCId);
        setCoachList(Array.isArray(cochResponse) ? cochResponse : [])
        const sprtResponse = await func.getSportsByCoach(getDetails.coachId);
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const progResponse = await func.program(null);
        setProgramList(Array.isArray(progResponse) ? progResponse : [])
        setBatchId(getDetails.batchId);
        setBatchName(getDetails.batchName);
        setHpcId(getDetails.geoHPCId);
        setGeoId(getDetails.geographyId)
        setCoachId(getDetails.coachId);
        setSportId(getDetails.sportId);
        setProgramId(getDetails.programId);
        setBatchStatus(getDetails.batchStatus);
    }

    function deleteBatch(btchId: any) {
        const deleteBatch = api.HPCBatch + '/' + btchId + '/' + 0;
        fetch(deleteBatch, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchBatchInfo();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    function callFunc(module: any) {
        setOpenModalOthers(false)
        if (module == "schedule") {
            setCallModule("schedule")
            setOpenModalOthers(true)
        } else if (module == "batchathletes") {
            setCallModule("batchathletes")
            setOpenModalOthers(true)
        } else if (module == "attendance") {
            setCallModule("attendance")
            setOpenModalOthers(true)
        } else if (module == "assessment") {
            setCallModule("assessment")
            setOpenModalOthers(true)
        }
    }

    async function dispFunc(btch: any, val: any) {
        setOpenModalOthers(false);
        setTitleName(btch.batchName);
        if (val == 'count') {
            const athltResponse = await func.hpcAthletesByBatch(btch.batchId);
            setScdlOrCount(Array.isArray(athltResponse) ? athltResponse : []);
            setCallModule("count")
            setOpenModalOthers(true)
        } else if (val == 'scdl') {
            const scdlResponse = await func.hpcSchedulesByBatch(btch.batchId);
            setScdlOrCount(Array.isArray(scdlResponse) ? scdlResponse : []);
            setCallModule("scdl")
            setOpenModalOthers(true)
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>HPC Batch</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newBatch() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Batch">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                    <div className="row">
                                        {filteredData.map((btch: any) => (
                                            <>
                                                <div className="col-lg-3">
                                                    <div className="card" style={{ padding: "18px" }}>
                                                        <div className="card-header d-flex justify-content-between">
                                                            <h5 className="text-center">{btch.batchName}</h5>
                                                            <div className="dropdown text-center">
                                                                <Link to="#" className="d-flex flex-column align-items-center text-decoration-none action-icon dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="fas fa-ellipsis-v" />
                                                                    <div className="dropdown-menu dropdown-menu-end">
                                                                        <Link className="dropdown-item" to="#" onClick={() => editBatch(btch.batchId)}><i className="fas fa-pencil" />Edit</Link>
                                                                        <Link className="dropdown-item" to="#" onClick={() => deleteBatch(btch.batchId)}><i className="fas fa-trash" />Delete</Link>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center mb-2">
                                                                <i className="fas fa-location-dot" />
                                                                <span className="ms-3">{btch.center.geoHPCName}</span>
                                                            </div>

                                                            <div className="d-flex align-items-center mb-2">
                                                                <i className="fas fa-person-running" />
                                                                <span className="ms-3">{btch.sport.sportName}</span>
                                                            </div>

                                                            <div className="d-flex align-items-center mb-2">
                                                                <i className="fas fa-book-open" />
                                                                <span className="ms-3">{btch.program.programName}</span>
                                                            </div>

                                                            <div className="d-flex align-items-center">
                                                                <i className="fas fa-person" />
                                                                <span className="ms-4">{btch.coach.coachName}</span>
                                                            </div>

                                                            <div className="d-flex align-items-center">
                                                                <i className={btch.status.id == 0 ? "fas fa-toggle-off" : "fas fa-toggle-on"} />
                                                                <span className="ms-3">{btch.status.name}</span>
                                                            </div>
                                                        </div>

                                                        <div className="row g-2 px-3 pb-3">
                                                            <div className="col-6">
                                                                <Link to="#" onClick={() => dispFunc(btch, 'count')} className="d-flex align-items-center text-decoration-none">
                                                                    <i className="fas fa-users" />
                                                                    <span className="ms-2">{btch.athleteCount}</span>
                                                                </Link>
                                                            </div>

                                                            <div className="col-6">
                                                                <Link to="#" onClick={() => dispFunc(btch, 'scdl')} className="d-flex  align-items-center text-decoration-none">
                                                                    <i className="fas fa-calendar" />
                                                                    <div className="d-flex flex-column ms-2">
                                                                        <small>{btch.schedule.totalSchedules + " / Week"}</small>
                                                                        <small>{btch.schedule.displayDays}</small>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                        <div className="card-footer">
                                                            <div className="d-flex flex-nowrap gap-1 batch-footer-actions">
                                                                <div className="flex-fill text-center">
                                                                    <Link to="#" onClick={() => callFunc('schedule')} className="d-flex flex-column align-items-center text-decoration-none">
                                                                        <i className="fas fa-calendar"></i>
                                                                        <small>Schedule</small>
                                                                    </Link>
                                                                </div>
                                                                <div className="flex-fill text-center">
                                                                    <Link to="#" onClick={() => callFunc('batchathletes')} className="d-flex flex-column align-items-center text-decoration-none">
                                                                        <i className="fas fa-users"></i>
                                                                        <small>Athletes</small>
                                                                    </Link>
                                                                </div>
                                                                <div className="flex-fill text-center">
                                                                    <Link to="#" onClick={() => callFunc('attendance')} className="d-flex flex-column align-items-center text-decoration-none">
                                                                        <i className="fas fa-user-clock"></i>
                                                                        <small>Attendance</small>
                                                                    </Link>
                                                                </div>
                                                                <div className="flex-fill text-center">
                                                                    {/* <div className="dropdown text-center">
                                                                        <Link to="#" className="d-flex flex-column align-items-center text-decoration-none action-icon dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <i className="fas fa-ellipsis" />
                                                                            <small>More</small>
                                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                                <Link className="dropdown-item" to="#" onClick={() => deleteBatch(btch.batchId)}><i className="fas fa-trash" />Delete</Link>
                                                                            </div>
                                                                        </Link>
                                                                    </div> */}
                                                                    <Link to="#" onClick={() => callFunc('assessment')} className="d-flex flex-column align-items-center text-decoration-none">
                                                                        <i className="fas fa-clipboard"></i>
                                                                        <small>Assessment</small>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <style>
                                                                {`
                                                                    .batch-footer-actions {
                                                                        width: 100%;
                                                                    }

                                                                    .batch-footer-actions > .flex-fill {
                                                                        min-width: 0;
                                                                        flex: 1 1 0 !important;
                                                                    }

                                                                    .batch-footer-actions small {
                                                                        font-size: 12px;
                                                                        line-height: 1.2;
                                                                        text-align: center;
                                                                    }

                                                                    .batch-footer-actions i {
                                                                        margin-bottom: 4px;
                                                                    }

                                                                    @media (max-width: 576px) {
                                                                        .batch-footer-actions {
                                                                            gap: 2px !important;
                                                                        }

                                                                        .batch-footer-actions small {
                                                                            font-size: .675em;
                                                                        }

                                                                        .batch-footer-actions i {
                                                                            font-size: 14px;
                                                                        }
                                                                    }
                                                                `}
                                                            </style>
                                                        </div>
                                                    </div>
                                                </div >
                                            </>
                                        ))}
                                    </div>
                                </div >
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <Modal
                show={openModal}
                size="lg"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Batch</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">State Name</label>
                                    <Select
                                        value={geoList.find(state => state.geographyId === geoId) ? {
                                            value: geoId,
                                            label: geoList.find(state => state.geographyId === geoId).geographyName
                                        } : null}
                                        onChange={async (e) => {
                                            setGeoId(e.value);
                                            const hpcResponse = await func.getHpcByGeography(e.value);
                                            setHpcList(Array.isArray(hpcResponse) ? hpcResponse : [])
                                        }}
                                        required
                                        styles={customSelect}
                                        placeholder="Select State"
                                        options={geoList.map(state => ({
                                            value: state.geographyId,
                                            label: state.geographyName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Center</label>
                                    <Select
                                        value={hpcList.find(hpc => hpc.geoHPCId === hpcId) ? {
                                            value: hpcId,
                                            label: hpcList.find(hpc => hpc.geoHPCId === hpcId).geoHPCName
                                        } : null}
                                        onChange={async (e) => {
                                            setHpcId(e.value);
                                            const cochResponse = await func.getCoachesByHpc(e.value);
                                            setCoachList(Array.isArray(cochResponse) ? cochResponse : [])
                                        }}
                                        required
                                        styles={customSelect}
                                        placeholder="Select Center"
                                        options={hpcList.map(hpc => ({
                                            value: hpc.geoHPCId,
                                            label: hpc.geoHPCName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Coach Name</label>
                                    <Select
                                        value={coachList.find(coch => coch.userId === coachId) ? {
                                            value: coachId,
                                            label: coachList.find(coch => coch.userId === coachId).coachName
                                        } : null}
                                        onChange={async (e) => {
                                            setCoachId(e.value);
                                            const sprtResponse = await func.getSportsByCoach(e.value);
                                            setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
                                        }}
                                        required
                                        styles={customSelect}
                                        placeholder="Select Coach"
                                        options={coachList.map(coch => ({
                                            value: coch.userId,
                                            label: coch.coachName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Sport Name</label>
                                    <Select
                                        value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                            value: sportId,
                                            label: sportList.find(sprt => sprt.sportId === sportId).sportsName
                                        } : null}
                                        onChange={async (e) => {
                                            setSportId(e.value);
                                        }}
                                        required
                                        styles={customSelect}
                                        placeholder="Select Sport"
                                        options={sportList.map(sprt => ({
                                            value: sprt.sportId,
                                            label: sprt.sportsName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Program Level</label>
                                    <Select
                                        value={programList.find(prog => prog.programId === programId) ? {
                                            value: programId,
                                            label: programList.find(prog => prog.programId === programId).programName
                                        } : null}
                                        onChange={async (e) => {
                                            setProgramId(e.value);
                                        }}
                                        required
                                        styles={customSelect}
                                        placeholder="Select Program"
                                        options={programList.map(prog => ({
                                            value: prog.programId,
                                            label: prog.programName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Batch Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="batchname"
                                        placeholder="Enter Batch Name"
                                        required
                                        value={batchName}
                                        onChange={(e) => setBatchName(e.target.value)}
                                    />
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={batchStatus === '1'}
                                                    id="geoBatchStatus"
                                                    onChange={(e) => {
                                                        setBatchStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>

            <Modal
                show={openModalOthers}
                centered
                size={(callModule == 'count' || callModule == 'scdl') ? "md " : "xl "}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{callModule === 'count' ? "Athletes of " + titleName : callModule === 'scdl' ? "Schedules of " + titleName : ""}</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => { setOpenModalOthers(false); fetchBatchInfo() }}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    {callModule == 'schedule' ? <HPCSchedules /> : callModule == 'batchathletes' ? <HPCBatchAthlete /> :
                        callModule == 'attendance' ? <HPCAttendance /> : callModule == 'assessment' ? <HPCAssessment /> : ""}
                    {(callModule == "count" || callModule == "scdl") ?
                        <div className="tab-content">
                            <div
                                className="tab-pane fade show active"
                                id="nav-Recent"
                                role="tabpanel"
                                aria-labelledby={"nav-Recent-tab" + 1}
                                tabIndex={0}
                            >
                                <div className="table-responsive table-datatble">
                                    <DataTable
                                        className="table datatable"
                                        value={scdlOrCount}
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                        pageLinkSize={3}
                                    >
                                        <Column
                                            sortable
                                            headerClassName="text-uppercase"
                                            // field="slNo"
                                            header="Sl &nbsp; No"
                                            body={(rowData, options) =>
                                                options.rowIndex + 1
                                            }
                                        ></Column>
                                        <Column
                                            sortable
                                            headerClassName="text-uppercase"
                                            field={callModule === "count" ? "athleteName" : callModule === "scdl" ? "scheduleDate" : ""}
                                            header={callModule === "count" ? "Athlete Name" : callModule === "scdl" ? "Schedule Date" : ""}
                                            className="table-inset-btn"
                                            body={callModule === "scdl" ? (rowData) => formatDate(rowData.scheduleDate) : undefined}
                                        ></Column>
                                        <Column
                                            sortable
                                            headerClassName="text-uppercase"
                                            field={callModule === "count" ? "genderName" : callModule === "scdl" ? "scheduleStartTime" : ""}
                                            header={callModule === "count" ? "Gender Name" : callModule === "scdl" ? "Start Time" : ""}
                                            className="table-inset-btn"
                                        ></Column>
                                        {callModule === "scdl" ?
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleEndTime"
                                                header="End Time"
                                                className="table-inset-btn"
                                            ></Column>
                                            : null}
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                        : ""}
                </ModalBody>
            </Modal>
        </>
    );
}

export default TrialBatch;